module.exports = __webpack_public_path__ + "media/stylesheets/images/mattrz_lp/logos/logo-13-fef5f8ca7d35f1a5d22dde51438c3a7c.png";